export function NotFound(){
    return (
        <div>
            <div className={"opacity-0"}>1</div>
            <div className={"mx-auto bg-white container text-center rounded-lg mt-10 px-5"}>
                <h2 className={"text-xl"}>Diese Seite wurde nicht gefunden!</h2>
                Wenn du ein neues Board erstellen möchtest, klicke hier
            </div>
        </div>
    )
}